export const COPY_TEXT = 'Copied to clipboard';
